/**
 * Modellkép betöltése a public/images/models mappából.
 *
 * Az elsődleges képek a szerveren lévő .png fájlok (ezek nincsenek a forrásban, kitelepítéskor nem szabad
 * felülírni az images mappát). Ha nincs .png, a forrásban lévő .jpg/.jpeg/.webp képre esik vissza.
 * A nem létező fájlra a szerver az index.html-t adja vissza, ami nem kép, így az onerror ág fut le.
 * Sorban kipróbálja a kiterjesztéseket, és az első betölthető képet adja vissza, különben a helyőrzőt.
 */
export const MODEL_IMAGE_PLACEHOLDER = "/images/models/model_placeholder.png";

const EXTENSIONS = ["png", "jpg", "jpeg", "webp"];

export const loadModelImage = (modelName) =>
    new Promise((resolve) => {
        const name = String(modelName ?? "").trim();
        if (!name) {
            resolve(MODEL_IMAGE_PLACEHOLDER);
            return;
        }
        const base = `/images/models/${encodeURIComponent(name)}`;
        const tryAt = (i) => {
            if (i >= EXTENSIONS.length) {
                resolve(MODEL_IMAGE_PLACEHOLDER);
                return;
            }
            const src = `${base}.${EXTENSIONS[i]}`;
            const img = new Image();
            img.onload = () => resolve(src);
            img.onerror = () => tryAt(i + 1);
            img.src = src;
        };
        tryAt(0);
    });
